import * as yup from 'yup'

const schemaUserCompany = (isEdit) =>
  yup.object().shape({
    ...(!isEdit && {
      companyId: yup.object().required().typeError('Preencha esse campo'),
    }),
    profileId: yup.string().required(),
  })

export default schemaUserCompany
